import styled from "styled-components"
import { MenuItem } from "@mui/material"
import { theme } from "@op-str/op-component-library"

export const IndentedMenuItem = styled(MenuItem)`
  margin-left: ${theme.spacing.m};
  margin-right: ${theme.spacing.m};
`
